module.exports = __webpack_public_path__ + "img/work-3.4be02d23.png";